import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";

function MondayHappyHoursPromoFun(props) {
    const {
        app: { brandId },
        theme,
    } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const domain = "Fun88";

    return (
        <>
            <InformationWrapper>
                {/* Top Caption */}

                <TopCaption>
                    <h4>Monday Happy Hour</h4>
                    <h6>Deposit & Win Instantly</h6>
                    <p>
                        Deposit during Happy Hour (6 PM - 7 PM) every Monday and receive an instant bonus to kickstart your play.
                    </p>
                </TopCaption>


                <RestSecWrap>
                {/* Left */}
                <LeftSecWrap>
                    <SectionTitle>
                        <p>How to <br /> <span>Participate</span></p>
                         <img
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourQMIconDesk}`}
                            alt="question mark"
                            className=""
                         />
                    </SectionTitle>

                    <StepsRow>
                        <StepCard>
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourSteps01Desk}`}
                                alt="Model"
                                className="modelImg"
                            />
                        </StepCard>

                        <StepCard>
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourSteps02Desk}`}
                                alt="Model"
                                className="modelImg"
                            />
                        </StepCard>

                        <StepCard>
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourSteps03Desk}`}
                                alt="Model"
                                className="modelImg"
                            />
                        </StepCard>
                    </StepsRow>
                </LeftSecWrap>


                {/* Middle */}
                <ModelWrapper>
                    <img
                        src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourModelDesk}`}
                        alt="Model"
                        className="modelImg"
                    />
                </ModelWrapper>

                <RightSecWrap>
                    {/* Right */}
                    <TermsTitle>
                        <p>Terms & <br /> <span>Conditions</span></p>
                         <img
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.mondayHappyHourAlertIconDesk}`}
                            alt="alert icon"
                            className=""
                         />
                    </TermsTitle>

                    <TermsCard>
                        <ul>
                            <li>Instant bonus up to <strong>₹206</strong></li>
                            <li>
                                Valid <strong>once per user every Monday</strong>
                            </li>
                            <li>
                                Bonus wagering requirements apply
                            </li>
                            <li>Estimated total prize pool: <strong>₹52,00,000</strong></li>
                            <li>Deposits made <strong>outside the 6-7 PM <br /> window are not eligible</strong></li>
                            <li><strong>{domain} reserves the right </strong> to modify or <br /> cancel the promotion without prior notice</li>
                            <li><strong>General {domain} terms & conditions apply</strong></li>
                        </ul>
                    </TermsCard>
                </RightSecWrap>
                </RestSecWrap>
            </InformationWrapper>

        </>
    );
}

export default withTheme(withAppContext(MondayHappyHoursPromoFun));

/* ===================== STYLES ===================== */

const InformationWrapper = styled.div`
  width: 98%;
  height: auto;
  padding: 1.5rem 0 0rem 0;
  margin: 0em 1.2em 0 1.2em;
  border: 1px solid #fff;
  display: flex;
  flex-direction: column;
  background: #ebebeb;
  overflow: hidden;
  position: relative;

  .boldText {
    color: ${theme("palette.informationWrapperPromoBoldText")};
    font-weight: 700;
  }

  .boldTextLite {
    color: #ffffff;
    font-weight: 700;
  }

  .brandColor {
    color: ${theme("palette.suprChknRushBrandTextColor")};
    font-weight: 700;
  }
`;

const TopCaption = styled.div`
  width: 90%;
  margin-bottom: 2rem;
  max-width: 1520px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 2em auto 3em auto;
  position: relative;
  background-color: #FFF;
  border-radius: 12px;
  padding: 10px;

  & h4 {
    color: ${theme("palette.mondayHappyHourTextColor")};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    margin: 3px 0px;
  }

  & h6 {
    color: rgba(68, 68, 68, 0.50);
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    margin: 3px 0px;
  }

  & p {
        color: #444;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 171.429% */
        margin: 3px 0px;
  }
`;

const ModelWrapper = styled.div`
  width: 30%;
  height: auto;

  .modelImg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(0px 12px 30px rgba(0, 0, 0, 0.7));
  }
`;

const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.3rem;
  margin-bottom: 1rem;
  align-items: center;
  margin: 5px auto;
  width: 75%;

  & p {
    color: ${theme("palette.mondayHappyHourTextColor")};
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    margin: 3px 0px;
  }

  span {
    color: rgba(68, 68, 68, 0.50);
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    margin: 3px 0px;
  }

  & img {
    width: 110px;
    height: 130px;
    object-fit: contain;
  }
`;

const StepsRow = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;
  flex-direction: column;
`;

const StepCard = styled.div`
    width: 100%;
    height: auto;
    border-radius: 10px;
    display: flex;
    justify-content: center;

    img {
        width: 75%;
        height: auto;
        border-radius: 8px;
        object-fit: contain;
    }
  
`;

const TermsTitle = styled.div`
  display: flex;
  gap: 0.4rem;
  margin-top: 2.2rem;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  margin: 5px auto;

  & p {
    color: ${theme("palette.mondayHappyHourTextColor")};
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    margin: 3px 0px;
  }

  span {
    color: rgba(68, 68, 68, 0.50);
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    margin: 3px 0px;
  }

  & img {
    width: 110px;
    height: 130px;
    object-fit: contain;
  }
`;

const TermsCard = styled.div`
  width: 100%;
  height: 75%;
  background: rgba(0, 0, 0, 0.45);
  padding: 22px 28px;
  position: relative;
  display: flex;
  align-items: center;
  background-color: #FFF;
  border-radius: 12px;

  &::before{
    content: "";
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.mondayHappyHourGiftIconDesk")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    left: -55px;
    bottom: -40px;
    width: 120px;
    height: 110px;
  }

  ul {
    margin: 0;
    padding-left: 4.15rem;
    display: flex;
    flex-direction: column;
    gap: 0.55rem;

    li {
      font-size: 18px;
      color: #444;
      line-height: 1.35;
      font-weight: 400;

      & strong {
        color: #444;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
      }
    }
  }
`;

const LeftSecWrap = styled.div`
    width: 30%;
    height: auto;
    display: flex;
    flex-direction: column;
    padding-bottom: 5em;
    position: relative;
`

const RightSecWrap = styled.div`
    width: 40%;
    height: auto;
    display: flex;
    flex-direction: column;
    padding-bottom: 5em;
`

const RestSecWrap = styled.div`
    display: flex;
    width: 90%;
    justify-content: center;
    gap: 10px;
    max-width: 1520px;
    margin: 0 auto;
`